<template>
  <div>
      <el-container :class="{headerheight:defaultActive!=='/'}">
       <el-header :class="{homeactive: defaultActive==='/'}" id="headers">
        <div class="logo">
          <img src="../assets/img/63fddb7f6f5f4c5da930abd8509b5c6.png" mode="widthFix" style="width:150px;"/>
        </div>
        <el-menu
          :default-active="defaultActive"
          mode="horizontal"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-menu-item index="/news">关于我们</el-menu-item> -->
          <el-submenu index="/news">
    <template slot="title">
      <div @click="tonews">关于我们</div>
    </template>
    <el-menu-item index="/news" >董事长寄语</el-menu-item>
    <el-menu-item index="news?id=1">企业简介</el-menu-item>
    <el-menu-item index="news?id=2">企业荣誉</el-menu-item>
    <el-menu-item index="news?id=3">企业理念</el-menu-item>
    <el-menu-item index="news?id=4">团队风采</el-menu-item>
  </el-submenu>
          <!-- <el-menu-item index="/product">前瞻战略</el-menu-item> -->
           <el-submenu index="/product">
    <template slot="title">
      <div @click="toproduct">前瞻战略</div>
    </template>
    <el-menu-item index="/product">大健康食品产业链</el-menu-item>
    <el-menu-item index="product?id=1">循环经济乡村振兴</el-menu-item>
  </el-submenu>
          <!-- <el-menu-item index="/case">发展领域</el-menu-item> -->
           <el-submenu index="/case">
    <template slot="title">
      <div @click="tocase">发展领域</div>
    </template>
    <el-menu-item index="/case">智慧团膳连锁产业</el-menu-item>
    <el-menu-item index="case?id=1">智能中央厨房产业</el-menu-item>
    <el-menu-item index="case?id=2">食品供应链产业</el-menu-item>
    <el-menu-item index="case?id=3">现代农业产业</el-menu-item>
    <el-menu-item index="case?id=4">休闲康养产业</el-menu-item>
  </el-submenu>
          <!-- <el-menu-item index="/goin">业务优势</el-menu-item> -->
           <el-submenu index="/goin">
    <template slot="title">
      <div @click="togoin">业务优势</div>
    </template>
    <el-menu-item index="/goin">智能生产设备</el-menu-item>
    <el-menu-item index="goin?id=1">智慧管理系统</el-menu-item>
    <!-- <el-menu-item index="goin?id=2">净菜加工</el-menu-item> -->
    <el-menu-item index="goin?id=2">五行膳食研创</el-menu-item>
    <el-menu-item index="goin?id=3">聚利和商学院</el-menu-item>
    <el-menu-item index="goin?id=4">增值服务</el-menu-item>
  </el-submenu>
          <el-menu-item index="/download">成功案例</el-menu-item>
          <!-- <el-menu-item index="/buildings">新闻动态</el-menu-item> -->
           <el-submenu index="/buildings">
    <template slot="title">
      <div @click="tobuildings">新闻动态</div>
    </template>
    <el-menu-item index="/buildings">企业新闻</el-menu-item>
    <el-menu-item index="buildings?id=1">健康食讯</el-menu-item>
  </el-submenu>
          <el-menu-item index="/contactme">联系我们</el-menu-item>
            <el-submenu index="2" style="margin-left:5vw;">
            <template slot="title">微信公众号</template>
            <div class="bannerimgbox">
              <img src="../assets/img/wechat123.png" alt="" class="headnavimg">
            </div>
          </el-submenu>
           <el-submenu index="3" style="margin-right:3vw;">
            <template slot="title">企业抖音号</template>
            <div class="bannerimgbox">
              <img src="../assets/img/_u89.png" alt="" class="headnavimg">
            </div>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "headernav",
  data(){
      return{
        router: true,
      }
  },
  props: {
    defaultActive: {
      type: String,
      default: ""
    },
  },
  created(){
  window.console.log(this.defaultActive)
  },
  methods:{
    tonews(){
       this.$router.push({ path: "news" });
    },
    toproduct(){
       this.$router.push({ path: "product" });
    },
    tocase(){
 this.$router.push({ path: "case" });
    },
    togoin(){
      this.$router.push({ path: "goin" });
    },
    tobuildings(){
       this.$router.push({ path: "buildings" });
    }
  }
};
</script>
<style lang="scss">
.homeactive{
  .el-menu-item{
color:#fff!important;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
  display: none;
}
.bannerimgbox{
  background: #fff;
  padding:10px;
  .headnavimg{
    width:200px;
    height:200px;
    vertical-align: middle;
  }
}
/deep/ .el-submenu__title{
 color: #555555!important ;
  }
.headerheight{
  height:55px;
}
#headers{
  animation: headerh 1s 1 linear;
}
 @keyframes headerh{
           0%{
             margin-top:-55px;
             opacity: 0;
           }
           100%{
             margin-top:0px;
             opacity: 1;
           }
        }
 @keyframes topheader{
           0%{
             top:-50px;
             opacity: 0;
           }
           100%{
             height:0px;
             opacity: 1;
           }
        }
.homeactive{
  position: fixed;
  left:0px;
  top:0px;
  z-index: 1000;
  animation: topheader 1s 1 linear;
   /deep/ .el-menu-item{
   color:#fff!important;
  }
/deep/ .el-submenu__title{
color:#fff!important;
  }
 .el-menu--horizontal > .el-menu-item.is-active{
    color: #409EFF !important;
    border:none!important;
  }
}
</style>